(() => {
  const loadTurnstile = () => {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (window.hiliteTurnstileLoading) return window.hiliteTurnstileLoading;
    window.hiliteTurnstileLoading = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.onload = () => resolve(window.turnstile);
      script.onerror = () => { script.remove(); window.hiliteTurnstileLoading = null; reject(new Error('load')); };
      document.head.append(script);
    });
    return window.hiliteTurnstileLoading;
  };
  const initialize = () => document.querySelectorAll('form[data-hilite-contact]').forEach((form) => {
    if (form.dataset.initialized) return;
    form.dataset.initialized = 'true';
    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('[data-contact-status]');
    const widget = form.querySelector('[data-contact-widget]');
    let widgetId;
    let loading = false;
    let sending = false;
    const show = (message, success = false) => {
      status.hidden = false;
      status.textContent = message;
      status.setAttribute('role', success ? 'status' : 'alert');
      if (success) status.setAttribute('data-hilite-contact-success', '');
      else status.removeAttribute('data-hilite-contact-success');
    };
    const start = async () => {
      if (loading || widgetId !== undefined) return;
      loading = true;
      try {
        const turnstile = await loadTurnstile();
        widgetId = turnstile.render(widget, {
          sitekey: form.dataset.sitekey,
          action: 'contact',
          language: form.dataset.language === 'de' ? 'de' : 'en',
          callback: () => { if (!sending) button.disabled = false; },
          'expired-callback': () => { button.disabled = true; turnstile.reset(widgetId); },
          'error-callback': () => { button.disabled = true; show(form.dataset.verificationError); }
        });
      } catch { show(form.dataset.verificationError); }
      finally { loading = false; }
    };
    form.addEventListener('focusin', start);
    form.addEventListener('pointerdown', start);
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (sending || !form.reportValidity()) return;
      const token = widgetId !== undefined && window.turnstile?.getResponse(widgetId);
      if (!token) { show(form.dataset.verificationError); await start(); return; }
      sending = true;
      button.disabled = true;
      form.setAttribute('aria-busy', 'true');
      show(form.dataset.sending);
      const value = (name) => form.elements.namedItem(name)?.value || '';
      try {
        const response = await fetch(form.action, {
          method: 'POST',
          credentials: 'omit',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token, name: value('name'), email: value('email'), phone: value('phone'), message: value('message'), website: value('website'), language: form.dataset.language }),
          signal: AbortSignal.timeout(30000)
        });
        const result = await response.json();
        if (!response.ok || result.success !== true) throw new Error(result.error || 'delivery');
        form.reset();
        show(form.dataset.success, true);
        status.focus();
        form.dispatchEvent(new CustomEvent('hilite:contact-sent', { bubbles: true }));
      } catch (error) {
        show(error.message === 'verification' ? form.dataset.verificationError : form.dataset.deliveryError);
        status.focus();
      } finally {
        sending = false;
        form.removeAttribute('aria-busy');
        window.turnstile.reset(widgetId);
      }
    });
  });
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
